document.addEventListener('DOMContentLoaded', function () {
  const slides = document.querySelectorAll('.image-fade-slider .slide');
  const dots = document.querySelectorAll('.image-fade-slider .dot');
  let currentSlide = 0;
  const totalSlides = slides.length;

  function showSlide(index) {
    slides.forEach((slide, i) => {
      slide.classList.toggle('active', i === index);
    });
    dots.forEach((dot, i) => {
      dot.classList.toggle('active', i === index);
    });
    currentSlide = index;
  }

  function showNextSlide() {
    let nextSlide = (currentSlide + 1) % totalSlides;
    showSlide(nextSlide);
  }

  // Auto slide every 3 seconds
  let slideInterval = setInterval(showNextSlide, 3000);

  // Add event listeners to dots
  dots.forEach((dot) => {
    dot.addEventListener('click', function () {
      clearInterval(slideInterval); // Stop auto-cycling when user clicks a dot
      const slideIndex = parseInt(this.getAttribute('data-slide'));
      showSlide(slideIndex);
      slideInterval = setInterval(showNextSlide, 3000); // Restart auto-cycling
    });
  });

  // Start by showing the first slide
  showSlide(currentSlide);
});
